import axios from 'axios';

//Se mejorara en el proximo PR
export default axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	responseType: 'json',
});
